import React from 'react';
import PropTypes from 'prop-types';
import CardButton from 'components/cards/CardButton';

export default class ShowPanelCardCta extends React.Component {
  static propTypes = {
    ctaRenderer: PropTypes.shape({
      panelId: PropTypes.string,
      text: PropTypes.string,
    }).isRequired,
    onClick: PropTypes.func.isRequired,
    onEngage: PropTypes.func.isRequired,
    testIdText: PropTypes.string,
  };

  static defaultProps = {
    testIdText: undefined,
  };

  handleClick = () => {
    const {
      ctaRenderer,
      onClick,
      onEngage,
    } = this.props;
    onClick({ id: ctaRenderer.panelId });
    onEngage({ cta: 'show_panel' });
  };

  render() {
    const {
      ctaRenderer,
      testIdText,
    } = this.props;
    const { text } = ctaRenderer;
    return (
      <CardButton data-testid={testIdText} onClick={this.handleClick}>
        { text }
      </CardButton>
    );
  }
}
